import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadSupplementsRequestDto as RequestDto,
  ReadSupplementsResponseDto as ResponseDto,
} from "../../api/supplements/list/dtos";
import { Supplement } from "../../models";
import { Api } from "../../api";
import { PagingMeta } from "../../models/_system";

interface CallParams {
  _query: {
    location_id: number;
    category_id: number;
    page?: number;
    per_page?: number;
    lang?: string;
    search?: string;
  };
  instances: string[];
}

interface Data {
  data: Supplement[];
  meta: PagingMeta;
}
export const list = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "LIST_SUPPLEMENTS",
  Api.supplements.list,
  ({ data: { data, meta } }) => {
    return {
      data: data.map((i) => new Supplement(i)),
      meta: new PagingMeta(meta),
    };
  },
  (params) => {
    return {
      ...params,
      _query: {
        ...params._query,
        ...(params._query.search
          ? { filter: { name: params._query.search } }
          : {}),
      },
    };
  }
);
